angular
  .module('fca-used')
  .factory('tagging', taggingService);

taggingService.$inject = ['$window', '$state', 'CONFIG', '$log'];

function taggingService($window, $state, CONFIG, $log) {
  try {
    if ($window.digitalData) {
      $window.digitalData.page.pageInfo.vehicleBrand = CONFIG.brand.taggingName;
      $window.digitalData.page.pageInfo.language = CONFIG.language.id;
      $window.digitalData.page.pageInfo.countryCode = CONFIG.market.id;
    }
  } catch (error) {
    $log.warn('DTM script not loaded, are you using adblock? ' + error);
  }
  var prefix = CONFIG.brand.taggingName + ':' + CONFIG.market.id + ':shopping-tools';
  return {
    track: track
  };

  function track(options) {
    try {
      if ($window.digitalData) {
        $window.digitalData.page.pageInfo.url = $window.document.location.origin + $window.document.location.pathname + $state.href($state.current.name, $state.params);

        if (options.page) {
          $window.digitalData.page.pageInfo.pageName = prefix + ':' + options.page;
          $window.digitalData.page.category.primaryCategory = prefix + ':' + options.page;
          $window.digitalData.page.category.subCategory1 = prefix;
          $window.digitalData.page.category.subCategory2 = prefix + ':used';
          $window.digitalData.page.category.pageType = prefix;
        } else {
          delete $window.digitalData.page.pageInfo.pageName;
          delete $window.digitalData.page.category.primaryCategory;
          delete $window.digitalData.page.category.subCategory1;
          delete $window.digitalData.page.category.subCategory2;
          delete $window.digitalData.page.category.pageType;
        }

        if (options.usedVehicle) {
          $window.digitalData.page.pageInfo.usedvehicleBrand = options.usedVehicle.brandDescription;
          $window.digitalData.page.pageInfo.usedvehicleModel = options.usedVehicle.brandModelDescription;
          $window.digitalData.page.pageInfo.dealerID = options.usedVehicle.dealer.SINCOM + '.' + options.usedVehicle.dealer.SITECODE;
          $window.digitalData.page.pageInfo.dealerName = options.usedVehicle.dealer.COMPANYNAM;

          $window.digitalData.page.component.form.stepName = 'form';
          $window.digitalData.page.component.form.leadType = 'information-request';
          $window.digitalData.page.component.form.nameType = 'lead:information-request';
        } else {
          delete $window.digitalData.page.pageInfo.usedvehicleBrand;
          delete $window.digitalData.page.pageInfo.usedvehicleModel;
          delete $window.digitalData.page.pageInfo.dealerID;
          delete $window.digitalData.page.pageInfo.dealerName;

          delete $window.digitalData.page.component.form.stepName;
          delete $window.digitalData.page.component.form.leadType;
          delete $window.digitalData.page.component.form.nameType;
        }

        if (options.thankYou) {
          $window.digitalData.page.component.form.stepName = 'thankyou';
        }

        if (options.inventorySearch) {
          $window.digitalData.page.component.inventorySearch = options.inventorySearch;
        } else {
          delete $window.digitalData.page.component.inventorySearch;
        }
        if (options.vehicleBrand) {
          $window.digitalData.page.pageInfo.vehicleBrand = options.vehicleBrand;
        } else {
          $window.digitalData.page.pageInfo.vehicleBrand = CONFIG.brand.taggingName;
        }

        if (CONFIG.mkParams) {
          $window.digitalData.page.pageInfo = angular.extend($window.digitalData.page.pageInfo, CONFIG.mkParams);
        }

        try {
          _satellite.track(options.event || 'pageload');
        } catch (error) {
          $log.warn('Error in DTM script ' + error);
        }
      }
    } catch (error) {
      $log.warn('DTM script not loaded, are you using adblock? ' + error);
    }
  }
}
